var LAYOUT = /* @__PURE__ */ ((LAYOUT2) => {
  LAYOUT2["SIX_EQUAL_POINTS"] = "six_equal_points";
  LAYOUT2["NINE_EQUAL_POINTS"] = "nine_equal_points";
  LAYOUT2["TWENTY_FIVE_EQUAL_POINTS"] = "twenty_five_equal_points";
  LAYOUT2["RIGHT_SIDE_LIST"] = "right_side_list";
  LAYOUT2["TOP_SIDE_LIST"] = "top_side_list";
  LAYOUT2["LARGE_SMALL_WINDOW"] = "large_small_window";
  LAYOUT2["GRID_VIEW"] = "grid_view";
  return LAYOUT2;
})(LAYOUT || {});
var SettingMode = /* @__PURE__ */ ((SettingMode2) => {
  SettingMode2["SIMPLE"] = "simple";
  SettingMode2["DETAIL"] = "detail";
  return SettingMode2;
})(SettingMode || {});
export {
  LAYOUT,
  SettingMode
};
